import { store } from "../../../../..";
import { globalActions } from "../../../../../features/global/globalSlice";

export const loader = async ({ params }: any) => {
    const { teamId } = params;
    const settings = store.getState().global.settings;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    await Promise.all(promises);

    return {
        teamId,
    };
};

export default loader;
